import React, { useEffect, useState, useRef } from "react";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import { auth, db } from "../../Security/firebase-config";
import "../General-Page.css";
import "../General-Map-Approach.css"
import "../../utils/ImageHoverEffect.css";
import { applyImageZoomEffect } from '../../utils/ImageHoverEffect';
import Footer from "../../components/core-components/Footer";
import GuideImage from "../../components/core-components/GuideImage";
import Highlight from "../../components/core-components/Highlight";
import Favorites from "../../components/core-components/Favorites";
import GuideMediaPlaceholder from "../../components/core-components/GuideMediaPlaceholder";
import { useBlur } from "../../context/BlurContext";
import { buildPlannedGuideAssetPath } from "../../utils/guideMediaPlanning";

const PLANNED_BIND_PLANT_SPOTS = buildPlannedGuideAssetPath("discordrainbow.png");


const BindMapApproach = () => {
  const [userTeamId, setUserTeamId] = useState(null);
  const imageContainerRef = useRef(null);
  const { isBlurred } = useBlur(); // Access blur state

  useEffect(() => {
    const imageContainers = document.querySelectorAll(".image-hover-effect");

    if (imageContainers.length > 0) {
        console.log("✅ Found image-hover-effect elements:", imageContainers.length);
        
        const cleanupFunctions = [];
        
        imageContainers.forEach((container) => {
            const cleanup = applyImageZoomEffect(container);
            cleanupFunctions.push(cleanup);
        });

        return () => {
            console.log("🧹 Cleaning up all event listeners...");
            cleanupFunctions.forEach(cleanup => cleanup());
        };
    } else {
        console.error("❌ No image-hover-effect containers found!");
    }
}, []);
 

  useEffect(() => {
    console.log("userTeamId in BindMapApproach:", userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    const fetchUserTeamId = async (uid) => {
      try {
        const userDocRef = doc(db, "users", uid);
        console.log("Fetching user document:", userDocRef.path); // Log the Firestore path
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("Fetched user document data:", data); // Log the document data

          if (data.teamId) {
            console.log("Setting teamId:", data.teamId);
            setUserTeamId(data.teamId);
          } else {
            console.warn("No teamId found in user document. Setting teamId to null.");
            setUserTeamId(null);
          }
        } else {
          console.error("User document does not exist in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching user team ID:", error);
      }
    };

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated:", user.uid);
        fetchUserTeamId(user.uid); // Pass the UID to fetch the teamId
      } else {
        console.warn("No authenticated user found.");
        setUserTeamId(null); // Clear the teamId if the user logs out
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  // Page transition effect
  useEffect(() => {
    document.body.classList.add("no-transition");
    const pageContainer = document.querySelector(".page__container");
    pageContainer && pageContainer.classList.add("no-transition");

    const handleLoad = () => {
      document.body.classList.remove("no-transition");
      pageContainer && pageContainer.classList.remove("no-transition");
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);


  return (
    <div className={`page__container map-approach-page ${isBlurred ? "blurred-content" : ""}`}>
    <Highlight />
      <main className={`Main__content__container ${isBlurred ? "blurred-content" : ""}`}>
      <h1 className="M-A-Title">Bind Map Approach</h1>
        <ul className="accordian">
          <li>
            <input type="checkbox" name="accordian" id="Indv-Bind-first" defaultChecked />
              <label htmlFor="Indv-Bind-first">
                Map Zones
                {/* Favorites Component */}
                <Favorites 
                  headingId="Indv-Bind-map-zones"
                  headingContent="Map Zones"
                  pageLocation="/Bind-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="Map__Zone__flexbox accordian__content" data-container-id="Indv-Bind-map-zones">
                <div className="Map__zone__Image__container image-hover-effect" ref={imageContainerRef}>
                  <GuideImage src="/assets/Ind-Split/Bind-Map.png" alt="Discord Rainbow" />
                </div>
                <div className="map__zone__text__container">
                <p id="Indv-Bind-map-zones-1">
                  <strong className="strong-colon-titles">Zone 1:</strong> Defender-sided map areas where ATKers are typically taking a risk when fighting into them. 
                  Defenders normally do not need to use much of any util to fight for these map areas.
                </p>
                <p id="Indv-Bind-map-zones-2">
                  <strong className="strong-colon-titles">Zone 2:</strong> These map areas are called Lanes on Bind and are the areas ATKers need to take control of before hitting the site.
                </p>
                <p id="Indv-Bind-map-zones-3">
                  <strong className="strong-colon-titles">Zone 3:</strong> This area is the typical site space ATKers want at the very least to be able to get spike down and set up for the post-plant safely.
                </p>
                <p id="Indv-Bind-map-zones-4">
                  <strong className="strong-colon-titles">Zone 4:</strong> These areas are very defender-sided and are typically hard to fight into for the ATKers. Here, there is a risk vs reward mentality; 
                  it might be risky for ATKers to take this deeper map control space, but if they do, then the DEFenders’ retake is immensely harder. 
                  ATKers are prone to fighting for deeper map control when the DEFenders have big retake ultimates, when ATKers are at a numbers/econ disadvantage, 
                  or if DEFenders leave the space wide open.
                </p>
                </div>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Bind-second" />
              <label htmlFor="Indv-Bind-second">
                General Defense Rules
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Bind-general-defense-rules"
                  headingContent="General Defense Rules"
                  pageLocation="/Bind-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Bind-general-defense-rules">
              <ul>
                <li><strong className="strong-BP-1">Weak-Side Play</strong></li>
                <ul>
                  <li>Double up and fight for control of one lane.</li>
                  <li>If possible, hold onto one lane to simplify plant denial and retake scenarios.</li>
                  <li>If holding the lane is not feasible, focus on baiting out attacker utility while contesting the space.
                    This forces attackers to expend resources, leaving them less utility for site execution.</li>
                  <li><strong className="strong-colon-titles">Fallback strategy:</strong> Retreat while forcing attackers to burn utility, then regroup and hard-fight for site control as rotations arrive.</li>
                </ul>
              </ul>

              <ul>
                <li><strong className="strong-BP-1">B-Site Specifics</strong></li>
                <ul>
                  <li>If defenders are forced off-site: Hold elbow space. Losing elbow significantly increases the chances of site loss.</li>
                </ul>
              </ul>

              <ul>
                <li><strong className="strong-BP-1">TP Situations</strong></li>
                <ul>
                  <li>Use the teleporter (TP) strategically:</li>
                  <ul>
                    <li><strong className="strong-colon-titles">Crunch attackers:</strong> Coordinate with teammates in Hookah or Showers to trap attackers. Example: “Fight B-short with us; TP to B!”</li>
                    <li><strong  className="strong-colon-titles">High-risk scenarios:</strong> If site anchors are eliminated or pushed back to CT and rotates are delayed, retaking from CT alone is unlikely to succeed.</li>
                    <li>In such cases, consider a solo risky TP to force a fight, regain lane control (e.g., Hookah or Showers), and improve retake odds.</li>
                    <li><strong>When Not to TP:</strong></li>
                    <ul>
                      <li>If a teammate is flanking.</li>
                      <li>If TP doors have been opened, and an enemy might be inside.</li>
                      <li>If crunching Hookah without active teammate support.</li>
                    </ul>
                  </ul>
                </ul>
              </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Bind-third" />
              <label htmlFor="Indv-Bind-third">
                General Attack Rules
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Bind-general-attack-rules"
                  headingContent="General Attack Rules"
                  pageLocation="/Bind-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Bind-general-attack-rules">
                <ul>
                  <li><strong className="strong-BP-1">Avoid 5-man pushes</strong></li>
                  <ul>
                    <li>Instead of sending 5 players down a single lane, use a <strong className="accordion-strong-text">split push</strong> (e.g., 4-1 split), where one player lurks late after the main force executes.</li>
                    <li>Splitting forces defenders to divide their attention and reduces the risk of getting stalled.</li>
                  </ul>

                  <li><strong className="strong-BP-1">Why Splitting and TP Control Matters</strong></li>
                  <ul>
                    <li>Bind lacks a <strong className="accordion-strong-text">mid-lane</strong>, so there are fewer options for rotating across the map quickly.</li>
                    <li>Defenders usually divide into:
                      <ul>
                        <li><strong className="strong-colon-titles">Strong side:</strong> 3 defenders</li>
                        <li><strong className="strong-colon-titles">Weak side:</strong> 2 defenders</li>
                      </ul>
                    </li>
                    <li>Attackers should aim to exploit the <strong className="accordion-strong-text">weaker site</strong>.</li>
                    <li><strong> Teleporters (TPs) are key:</strong></li>
                    <ul>
                      <li>Teleporters allow <strong className="accordion-strong-text">faster rotations</strong> for attackers, unlike defenders who must rotate through spawn.</li>
                      <li>Controlling teleporters enables <strong className="accordion-strong-text">fake site hits</strong> and <strong className="accordion-strong-text">quick site switches</strong>.</li>
                    </ul>
                  </ul>

                  <li><strong className="strong-BP-1">Default Strategy on Bind</strong></li>
                  <ul>
                    <li><strong className="strong-colon-titles">Purpose:</strong> Gather information, identify the weak site, and take control of multiple <strong className="accordion-strong-text">Zone 2</strong> spaces with minimal risk.</li>
                  </ul>
                </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Bind-fourth" />
              <label htmlFor="Indv-Bind-fourth">
                How to Default
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Bind-how-to-default"
                  headingContent="How to Default"
                  pageLocation="/Bind-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Bind-how-to-default">
                <ul>
                  <li><strong className="strong-BP-1">Avoid 5-man pushes</strong></li>
                  <ul>
                    <li>Instead, split push (e.g., 4-1 split), with one player lurking late after the main force executes.</li>
                    <li>Splitting forces defenders to divide their attention and reduces the risk of getting stalled.</li>
                  </ul>

                  <li><strong className="strong-BP-1">Why Splitting and TP Control Matters</strong></li>
                  <ul>
                    <li>Bind lacks a <strong className="accordion-strong-text">mid-lane</strong>, limiting attackers' rotation options.</li>
                    <li>Defenders usually divide into:
                      <ul>
                        <li><strong className="strong-colon-titles">Strong side:</strong> 3 defenders</li>
                        <li><strong className="strong-colon-titles">Weak side:</strong> 2 defenders</li>
                      </ul>
                    </li>
                    <li>Attackers should aim to exploit the <strong>weaker site</strong>.</li>
                    <li><strong>Teleporters (TPs) are key:</strong></li>
                    <ul>
                      <li>Teleporters allow <strong className="accordion-strong-text">faster rotations</strong> for attackers, while defenders must rotate through spawn.</li>
                      <li>Controlling TPs enables <strong className="accordion-strong-text">fake site hits</strong> and <strong className="accordion-strong-text">quick site switches</strong>.</li>
                    </ul>
                  </ul>

                  <li><strong className="strong-BP-1">Default Strategy on Bind</strong></li>
                  <ul>
                    <li><strong className="strong-colon-titles">Purpose:</strong> Gather information, identify the weak site, and take control of multiple <strong> Zone 2 </strong> spaces with minimal risk.</li>
                  </ul>

                  <li><strong className="strong-BP-1">How to Default:</strong></li>
                  <ul>
                    <li><strong>Take Control of Zone 2 Spaces:</strong></li>
                    <ul>
                      <li>Pair an <strong className="accordion-strong-text"> Initiator and Duelist </strong> (e.g., Skye & Raze) to push a contested <strong className="accordion-strong-text"> Zone 2 </strong> (Showers, B-long, or Hookah).</li>
                      <li>Other players passively hold <strong className="accordion-strong-text"> Zone 2 </strong> for information and watch for defender aggression.</li>
                      <li><strong className="strong-colon-titles">Key Rule:</strong> Solo players holding space must <strong className="accordion-strong-text">avoid risks</strong> or lurking, as defenders will expect a default. Their job is to gather intel and maintain space.</li>
                    </ul>

                    <li><strong>Insert a Lurk:</strong></li>
                    <ul>
                      <li>Once <strong className="accordion-strong-text"> Zone 2 </strong> control is established, send a lurk (e.g., the Duelist) into that space to maintain pressure.</li>
                    </ul>

                    <li><strong>Take Another Zone 2:</strong></li>
                    <ul>
                      <li>The <strong className="accordion-strong-text"> Initiator </strong> then joins another player to secure a second <strong className="accordion-strong-text"> Zone 2 </strong> space.</li>
                    </ul>

                    <li><strong>Decision-Making:</strong></li>
                    <ul>
                      <li>After creating pressure across the map and denying defenders information, decide which site to hit.</li>
                      <li>Use the earlier <strong className="accordion-strong-text"> lurk </strong> to re-access the first <strong className="accordion-strong-text"> Zone 2 </strong> space if needed.</li>
                      <li>If not, the lurker can <strong className="accordion-strong-text">rotate via TPs</strong> or through spawn.</li>
                    </ul>
                  </ul>

                  <li><strong className="strong-BP-1">Default Variations with a Sentinel:</strong></li>
                  <ul>
                    <li><strong className="strong-colon-titles">1/1/1/2 Default:</strong> The <strong className="accordion-strong-text"> Sentinel </strong> and utility hold two <strong className="accordion-strong-text"> Zone 2 </strong> spaces (e.g., A-short and B-short).</li>
                    <li><strong className="strong-colon-titles">1/1/3 Default:</strong> The <strong className="accordion-strong-text"> Sentinel </strong> passively holds two lanes, while the Duelist, Initiator, and one teammate fight for a <strong className="accordion-strong-text"> Zone 2 </strong> space.</li>
                    <li><strong className="strong-colon-titles">2/1/2 Default:</strong> The <strong className="accordion-strong-text"> Sentinel </strong> supports two players in holding two <strong className="accordion-strong-text"> Zone 2 </strong> areas, enabling a stronger presence on both sides of the map.</li>
                  </ul>

                  <li><strong className="strong-BP-1">Post-Plant:</strong></li>
                  <ul>
                    <li>Always control at least <strong className="accordion-strong-text">two lanes</strong> for a successful post-plant setup.</li>
                  </ul>
                </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Bind-fifth" />
            <label htmlFor="Indv-Bind-fifth">
              Plant Spots
              {/* Favorites Component */}
              <Favorites
                headingId="Indv-Bind-plant-spots"
                headingContent="Plant Spots"
                pageLocation="/Bind-Map-Approach"
                teamId={userTeamId}
              />
            </label>
            <div className="Plant-Spots-flexbox accordian__content" data-container-id="Indv-Bind-plant-spots">
              
              <div className="Plant-Spots-Image__container image-hover-effect" ref={imageContainerRef}>
                <GuideMediaPlaceholder
                  label="Plant Spot Overview"
                  plannedAssetPath={PLANNED_BIND_PLANT_SPOTS}
                  withFrame={false}
                />
              </div>
              <div className="Plant-Spots-Image__container image-hover-effect" ref={imageContainerRef}>
                <GuideMediaPlaceholder
                  label="Alternate Plant Spot Overview"
                  plannedAssetPath={PLANNED_BIND_PLANT_SPOTS}
                  withFrame={false}
                />
              </div>
            </div>
          </li>

          <li>
          <input type="checkbox" name="accordian" id="Indv-Bind-sixth" />
          <label htmlFor="Indv-Bind-sixth">
            Exploiting Bad Enemy Comps
            {/* Favorites Component */}
            <Favorites
              headingId="Indv-Bind-bad-enemy-comps"
              headingContent="Exploiting Bad Enemy Comps"
              pageLocation="/Bind-Map-Approach"
              teamId={userTeamId}
            />
          </label>
          <div className="accordian__content" data-container-id="Indv-Bind-bad-enemy-comps">
            <ul>
              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-no-drone" />
                <label htmlFor="Indv-Bind-no-drone">VS No-drone</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>Comps without a drone initiator struggle to gather information.</li>
                        <li>Defaulting against them is strong; taking space and cutting noise for 20 seconds before re-hitting or faking is highly effective.</li>
                      </ul>
                    </li>
                    <li><strong>Defense</strong>
                      <ul>
                        <li>Play in strong positions to hold space.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-no-pop-flashes" />
                <label htmlFor="Indv-Bind-no-pop-flashes">VS No-Pop Flashes</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>Without pop-flashes, defenders struggle to set up aggressive trap plays.</li>
                        <li>This makes it easier to take spaces like B-long and Showers.</li>
                      </ul>
                    </li>
                    <li><strong>Defense</strong>
                      <ul>
                        <li>Holding off-angles and punishing early aggression becomes more effective.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-no-brimstone" />
                <label htmlFor="Indv-Bind-no-brimstone"> VS No Brimstone (Sub-optimal Smokes)</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>If their Smoker plays Showers often, a <strong>fast B-site hit</strong> through B-long is a strong counter.</li>
                        <li>Against Smokes that don’t regenerate, force early smoke usage by defaulting.</li>
                        <li>If Brimstone or Clove starts rounds on A-site, fake B pressure and <strong>teleport to A</strong>.</li>
                      </ul>
                    </li>
                    <li><strong>Defense</strong>
                      <ul>
                        <li>Holding <strong>Zone 2 Lanes</strong> is essential against non-regenerating smokes.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-solo-smokes" />
                <label htmlFor="Indv-Bind-solo-smokes">VS Solo Smokes</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>Defaulting is effective as the enemy Smoker can only cover limited angles.</li>
                        <li>Once site execution is delayed, <strong>waiting out the smokes</strong> before re-hitting is a strong strategy.</li>
                        <li><strong>Hookah Control:</strong> If they lack a <strong>Viper</strong>, sending a lurker into Hookah is more effective.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-no-sentinel" />
                <label htmlFor="Indv-Bind-no-sentinel"> VS No Sentinel</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>Lurks become much more viable.</li>
                        <li>However, avoid sending a lurker <strong>every round</strong>, or defenders will start actively clearing flanks.</li>
                        <li>Executing fakes is easier without a Sentinel’s defensive utility.</li>
                      </ul>
                    </li>
                    <li><strong>Defense</strong>
                      <ul>
                        <li>Flanking Showers or B-long becomes much stronger.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <input type="checkbox" name="bad-enemy-comps" id="Indv-Bind-no-nades-mollies" />
                <label htmlFor="Indv-Bind-no-nades-mollies">VS No Nades/Mollies</label>
                <div className="accordian__subcontent">
                  <ul>
                    <li><strong>Attack</strong>
                      <ul>
                        <li>Without mollies, defenders struggle to <strong>deny plants</strong>.</li>
                        <li>Post-plant setups should focus on <strong>strong positioning</strong> instead of relying on post-plant utility.</li>
                      </ul>
                    </li>
                    <li><strong>Defense</strong>
                      <ul>
                        <li>Retakes become easier as attackers have fewer <strong>stalling tools</strong>.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </li>


        </ul>
      </main>

      {/* Footer Section */}
      <section className="footer-section">
        <Footer />
      </section>
    </div>
  );
};

export default BindMapApproach;
